import React from 'react'
import { Tab, Tabs } from '@chilecompra/react-kit'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import AddProductsServicesContainer from '../containers/AddProductsServices/AddProductsServices.container'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import OnboardingDialogContainer from '../containers/OnboardingDialog/OnboardingDialog.container'
import SearchGoodsAndServicesByCategoryContainer from '../containers/SearchGoodsAndServicesByCategory/SearchGoodsAndServicesByCategory.container'
import SearchGoodsAndServicesHeader from '../containers/SearchGoodsAndServicesHeader/SearchGoodsAndServicesHeader.container'
import SearchGoodsAndServicesFooter from '../containers/SearchGoodsAndServicesFooter/SearchGoodsAndServicesFooter.container'
import { Column, Root, Row } from './SearchGoodsAndServices.styles'

/**
 * The SearchGoodsAndServices' page.
 */
const SearchGoodsAndServices = () => {
  return (
    <AuthorizationProviderContainer>
      <ProtectByAccessToken>
        <BrandLayout footer={<SearchGoodsAndServicesFooter />} header={<SearchGoodsAndServicesHeader />}>
          <Root>
            <Row>
              <Column md={12} lg={8}>
                <Tabs value="tab1" padding="34px 0 0" variant="fullWidth">
                  <Tab id="tab1" label="Buscar por producto o servicio">
                    <AddProductsServicesContainer />
                  </Tab>
                  <Tab id="tab2" label="Navegar por rubros">
                    <SearchGoodsAndServicesByCategoryContainer />
                  </Tab>
                </Tabs>
              </Column>
            </Row>
          </Root>
          <OnboardingDialogContainer />
        </BrandLayout>
      </ProtectByAccessToken>
    </AuthorizationProviderContainer>
  )
}

export default SearchGoodsAndServices
